import React from 'react'
import css from './css.module.scss'
import { Container } from '@material-ui/core'

export const LayoutAppPage: React.FC<any> = ({ children }) => {
  return <Container className={css['layout']}>{children}</Container>
}

export default LayoutAppPage
